import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import {
  doSaveOfferCatalog,
  doSaveOfferCatalogFailure,
  doSaveOfferSubscriptionSuccess,
  doSaveOfferSubscriptionFailure,
} from "../actions/offerCatalog";
import { fetchOfferEligibility, submitOfferSubscription } from "../api/offerCatalog";
import menuPaths from "../enum/menuPaths";

const flattenEligibilityResponse = data => {
  const segments = Array.isArray(data?.segments) ? data.segments : [];
  const offers = segments.reduce(
    (all, segment) => all.concat(Array.isArray(segment.offers) ? segment.offers : []),
    []
  );

  return { catalog: offers };
};

function* handleFetchOfferCatalog() {
  try {
    const { data } = yield call(fetchOfferEligibility);
    const { catalog } = flattenEligibilityResponse(data);
    yield put(doSaveOfferCatalog({ catalog }));
  } catch (e) {
    yield put(doSaveOfferCatalogFailure({ error: e }));
  }
}

// O BFF devolve `{status: "accepted" | "rejected"}`: so o aceite navega para a
// solicitacao concluida; a rejeicao (LOOP recusou) e uma falha da jornada.
function* handleRequestOfferSubscription(action) {
  const { offerId, productType } = action.payload;

  try {
    const { data } = yield call(submitOfferSubscription, offerId);
    if (data?.status === "rejected") {
      yield put(doSaveOfferSubscriptionFailure({ offerId, productType, error: data }));
      yield put(push(menuPaths.ADESAO_FALHA));
      return;
    }
    yield put(doSaveOfferSubscriptionSuccess({ offerId, productType }));
    yield put(push(menuPaths.ADESAO_SUCESSO));
  } catch (e) {
    yield put(doSaveOfferSubscriptionFailure({ offerId, productType, error: e }));
    yield put(push(menuPaths.ADESAO_FALHA));
  }
}

export { flattenEligibilityResponse, handleFetchOfferCatalog, handleRequestOfferSubscription };
